import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const STAGING_MODE_QUERY_KEY = ["staging-mode"] as const;

/**
 * Global Staging Mode flag (admin_settings.staging_mode). Readable by anon so
 * the badge also renders on marketing/public routes.
 */
export function useStagingMode() {
  const { data: isStaging = false, isLoading } = useQuery({
    queryKey: STAGING_MODE_QUERY_KEY,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("admin_settings")
        .select("value")
        .eq("key", "staging_mode")
        .maybeSingle();

      if (error) return false;
      return data?.value === "true";
    },
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

  return { isStaging, isLoading };
}
